
    
        var maquetteH = require('maquette').h;
        var h = function(selector, props, children) {
          var attributes = Object.assign({}, props.attributes || {}, props);
          delete attributes["attributes"];

          // This should be done by pug-vdom, oh well...
          if (attributes.class) {
            selector += "." + attributes.class.trim().split(/ +/).join(".");
            delete attributes["class"];
          }

          return maquetteH(selector, attributes, children);
        }
      ;
    function render(context, h, text = (string) => string) {
  if (!pugVDOMRuntime) throw "pug-vdom runtime not found.";
  var runtime = pugVDOMRuntime
  var locals = context;
  var self = locals;
  var remainingKeys = pugVDOMRuntime.enterLocalsScope(locals);
  for (var prop in remainingKeys) {
    eval('var ' + prop + ' =  locals.' + prop);
  }
  var n0Child = []
  var n116Child = []
  var n117Child = []
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'modal-background'},{name:'onclick', val: this.dismiss}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n117 = h('div', props, n117Child)
  n116Child.push(n117)
  var n118Child = []
  var n119Child = []
  var n120Child = []
  n120Child = n120Child.concat(text(this.t('.title')))
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'modal-card-title'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n120 = h('p', props, n120Child)
  n119Child.push(n120)
  var n121Child = []
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'delete'},{name:'onclick', val: this.dismiss},{name:'type', val: "button"}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n121 = h('button', props, n121Child)
  n119Child.push(n121)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'modal-card-head'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n119 = h('header', props, n119Child)
  n118Child.push(n119)
  var n122Child = []
  var n123Child = []
  var n124Child = []
  var n125Child = []
  var n126Child = []
  n126Child = n126Child.concat(text(this.t('.start_time')))
  var props = {attributes: runtime.compileAttrs([], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n126 = h('th', props, n126Child)
  n125Child.push(n126)
  var n127Child = []
  n127Child = n127Child.concat(text(this.t('.end_time')))
  var props = {attributes: runtime.compileAttrs([], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n127 = h('th', props, n127Child)
  n125Child.push(n127)
  var props = {attributes: runtime.compileAttrs([], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n125 = h('tr', props, n125Child)
  n124Child.push(n125)
  var v128 = [].concat(this.shadow).concat([this.emptyRow()])
  Object.keys(v128).forEach(function (i) {
    var period = v128[i]
    var n129Child = []
    var n130Child = []
    var n131Child = []
    var props = {attributes: runtime.compileAttrs([{name:'name', val: `periods[${i}][start][date]`},{name:'type', val: "date"},{name:'value', val: period.start.date}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n131 = h('input', props, n131Child)
    n130Child.push(n131)
    var n132Child = []
    var props = {attributes: runtime.compileAttrs([{name:'name', val: `periods[${i}][start][time]`},{name:'type', val: "time"},{name:'value', val: period.start.time}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n132 = h('input', props, n132Child)
    n130Child.push(n132)
    var props = {attributes: runtime.compileAttrs([], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n130 = h('td', props, n130Child)
    n129Child.push(n130)
    var n133Child = []
    var n134Child = []
    var props = {attributes: runtime.compileAttrs([{name:'name', val: `periods[${i}][end][date]`},{name:'type', val: "date"},{name:'value', val: period.end.date}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n134 = h('input', props, n134Child)
    n133Child.push(n134)
    var n135Child = []
    var props = {attributes: runtime.compileAttrs([{name:'name', val: `periods[${i}][end][time]`},{name:'type', val: "time"},{name:'value', val: period.end.time}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n135 = h('input', props, n135Child)
    n133Child.push(n135)
    var props = {attributes: runtime.compileAttrs([], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n133 = h('td', props, n133Child)
    n129Child.push(n133)
    var props = {attributes: runtime.compileAttrs([{name:'key', val: `period-${i}`}], [])};
    if (props.attributes.id) props.key = props.attributes.id;
    var n129 = h('tr', props, n129Child)
    n124Child.push(n129)
  }.bind(this))
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'table'},{name:'class', val: 'is-bordered'},{name:'class', val: 'is-fullwidth'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n124 = h('table', props, n124Child)
  n123Child.push(n124)
  var props = {attributes: runtime.compileAttrs([{name:'afterCreate', val: this.bindForm},{name:'afterUpdate', val: this.bindForm},{name:'oninput', val: this.onInput}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n123 = h('form', props, n123Child)
  n122Child.push(n123)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'modal-card-body'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n122 = h('section', props, n122Child)
  n118Child.push(n122)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'modal-card'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n118 = h('div', props, n118Child)
  n116Child.push(n118)
  var props = {attributes: runtime.compileAttrs([{name:'class', val: 'meta-editor'},{name:'class', val: 'modal'},{name:'class', val: 'is-active'}], [])};
  if (props.attributes.id) props.key = props.attributes.id;
  var n116 = h('div', props, n116Child)
  n0Child.push(n116)
  pugVDOMRuntime.exitLocalsScope()
  return n0Child
}
;
    module.exports = function(locals) {
      locals = Object.assign(window.DEFAULT_TEMPLATE_LOCALS || {}, locals || {});
      return render.call(this, locals, h);
    };
  